export default __webpack_public_path__ + "static/media/GreenDesiredJob.ddfe8629.svg";